import { ReactNode } from 'react';

import { AccountFlagEnum } from '~/generated/graphql';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

type WhenProspectorProps = {
  children: ReactNode;
  cta?: ReactNode;
};
/**
 * A component which reveals UI for users that have access to prospector.
 * If a user doesn't have access to prospector, it can optionally display a CTA.
 *
 * @example
 * <WhenProspector>
 *  <div>Prospector, folks!</div>
 * </WhenProspector>
 *
 * @param {ReactNode} children the UI to reveal if the user has access to prospector
 * @param {ReactNode} cta optional CTA to display if the user doesn't have access to prospector
 * @returns {ReactNode | null} rendered children if the user has prospector access
 */
export function WhenProspector({ children, cta = null }: WhenProspectorProps) {
  const canAccessProspector = useFeatureFlag(AccountFlagEnum.AllowProspector)
    .enabled;
  const canAccessProspectorPreview = useFeatureFlag(
    AccountFlagEnum.RolloutPlatformProspectorUi,
  ).enabled;

  if (canAccessProspector || canAccessProspectorPreview) {
    return <>{children}</>;
  }

  return <>{cta}</>;
}
